var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElements(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "elements"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1480",
    cx: 1.25,
    cy: 1.25,
    r: 1.25,
    transform: "matrix(1 0 0 -1 12.8333 6.66687)",
    stroke: "#97979A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.81186 9.28663C0.975904 10.2203 0.957919 11.6289 1.72513 12.6197C3.24759 14.5861 4.91395 16.2524 6.88027 17.7749C7.87117 18.5421 9.27976 18.5241 10.2134 17.6882C12.7482 15.4185 15.0696 13.0466 17.3099 10.44C17.5314 10.1823 17.6699 9.86642 17.701 9.52804C17.8385 8.03167 18.121 3.72058 16.9502 2.54981C15.7794 1.37903 11.4683 1.66149 9.97197 1.79899C9.6336 1.83008 9.31774 1.96863 9.06004 2.19012C6.45344 4.4304 4.0815 6.75178 1.81186 9.28663Z",
    stroke: "#97979A",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 20",
    d: "M5.33335 11.6669L7.83335 14.1669",
    stroke: "#97979A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElements);
export default __webpack_public_path__ + "static/media/elements.7400b832c385103c858d990c9f88df3d.svg";
export { ForwardRef as ReactComponent };